export default require(`./${process.env.VUE_APP_CONFIG_ENVIRONMENT}.config.js`).default
